import React from "react";
import { View } from "react-native";

const SeparatedItems = ({ children, separator }) => {
  const items = React.Children.toArray(children).filter(Boolean);

  return (
    <View style={[{ alignItems: "center", flexDirection: "row" }]}>
      {items.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < items.length - 1 && separator}
        </React.Fragment>
      ))}
    </View>
  );
};

export default SeparatedItems;
